import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { TagOption } from 'app/models'

import { ApiService } from './api.service'
import { Mapper } from './mapper.service'

@Injectable({
  providedIn: 'root'
})
export class TagOptionService {

  private RESOURCE_ROUTE = 'v3/memberships/tag_options'

  constructor(private api: ApiService) { }

  public find(id: string): Observable<TagOption> {
    return this.api.findAs<TagOption>(`${this.RESOURCE_ROUTE}/${id}`, TagOption)
  }

  public findAll(params: any): Observable<TagOption[]> {
    return this.api.findAllAs<TagOption>(this.RESOURCE_ROUTE, params, TagOption)
  }

  public create(data: any): Observable<any> {
    return this.api.post(this.RESOURCE_ROUTE, data)
      .pipe(first())
      .pipe(map((r: any) => {
        if (r.result) {
          return Mapper.as<TagOption>(r.result, TagOption)
        }
        // @todo handle error
    }))
  }

  public delete(id: string): Observable<any> {
    return this.api.delete(`${this.RESOURCE_ROUTE}/${id}`).pipe(first())
  }
}
